import clsx from 'clsx'
import { computed, defineComponent } from 'vue'

import { type CommonToast } from '@/types/Toast'

interface Props {
  item: CommonToast
}

export default defineComponent<Props>((props) => {
  // #region Getters

  const statusClass = computed((): string => {
    switch (props.item.status) {
      case 'Successed':
        return clsx('')

      case 'Failed':
        return clsx('')

      default:
        return clsx('bg-primary-100 text-primary-900')
    }
  })

  // #endregion

  return () => (
    <div
      t-data='common-toast'
      class={[
        'flex min-h-11 w-[90vw] items-center space-x-2 rounded-sm border px-4 py-2.5 shadow-elevation-5 desktop:w-[564px]',
        statusClass.value
      ]}
    >
      <span
        t-data='common-toast-message'
        class='font-roboto text-body-1'
      >{props.item.message}
      </span>
    </div>
  )
}, {
  name: 'CommonToast',
  props: ['item']
})
